module.exports = __webpack_public_path__ + "static/media/hbcrm.992e5fd9.png";